import { CheckCircleIcon, ExclamationCircleIcon } from '../../Icons';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { checkCircleIconDefaultStyle, exclamationCircleIconDefaultStyle } from './messageBlockIconDefaultStyle';
import { jsx as _jsx } from "react/jsx-runtime";
export const MessageBlockIcon = props => {
  const {
    state,
    size,
    message
  } = props;
  const theme = useInterstateTheme();
  switch (state) {
    case 'error':
      {
        return /*#__PURE__*/_jsx(ExclamationCircleIcon, {
          ...exclamationCircleIconDefaultStyle(theme, size)
        });
      }
    case 'success':
      {
        return /*#__PURE__*/_jsx(CheckCircleIcon, {
          ...checkCircleIconDefaultStyle(theme, size)
        });
      }
    default:
      return null;
  }
};